import { Controller } from "stimulus";
import Rails from "@rails/ujs";

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.checkStatusAndRefresh();
  }

  checkStatusAndRefresh() {
    Rails.ajax({
      url: this.urlValue,
      type: 'GET',
      contentType: 'application/json',
      dataType: 'json',
      success: (response) => {
        this.refreshWhenComplete(response);
      },
    })
  }

  refreshWhenComplete(response) {
    if (response.status !== 'pending') {
      location.reload();
    } else {
      setTimeout(() => this.checkStatusAndRefresh(), 2000);
    }
  }
}
